<template>
  <div class="icons">
    <h2>Acciones de internacionalización UPB</h2>
    <hr />
    <div class="icons">
    <v-row>
      <v-col cols="12" md="8">
        <v-row>
        <v-col>
          <router-link to="/programas-internacionales">
            <font-awesome-icon class="home-icon" icon="globe" />
            <h3 class="mb-5">Programas internacionales</h3>
          </router-link>
          <p>Diseñados para desarrollar profesionales con visión global.</p>
        </v-col>
        <v-col>
          <router-link to="/convenios">
            <font-awesome-icon class="home-icon" icon="handshake" />
            <h3 class="mb-5">Convenios y membresías</h3>
          </router-link>
          <p>Las universidades que nos apoyan en nuestros programas.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-link to="/programas-internacionales">
            <font-awesome-icon class="home-icon" icon="list-alt" />
            <h3 class="mb-5">Actividades</h3>
          </router-link>
          <p>Revisa nuestras últimas actividades.</p>
        </v-col>
      </v-row>
      </v-col>
      <v-col cols="6" md="4">
        <div class="facebook-page">
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Funiversidad.privada.boliviana%2F&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
              :width="getFacebookWidth()"
              :height="getFacebookHeight()"
              style="border:none;overflow:hidden"
              scrolling="no"
              frameborder="0"
              allowTransparency="true"
              allow="encrypted-media"
            ></iframe>
        </div>
      </v-col>
    </v-row>
  </div>
  </div>
</template>

<script>
export default {
  methods: {
    getFacebookWidth: function () {
      return window.innerWidth / 2.7
    },
    getFacebookHeight: function () {
      return window.innerHeight / 2
    }
  }
}
</script>

<style scoped>
.icons {
  background-color: white;
  text-align: center;
  padding-left: 20vw;
  padding-right: 20vw;
  padding-top: 10vh;
}

.home-icon {
  width: 100px;
  height: 100px;
  color: #292f6d;
}

a {
  text-decoration: none;
}

h2 {
  font-size: 2.5rem;
  font-weight: normal;
}

.icons {
  text-align: center;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 10vh;
}

.home-icon {
  width: 100px;
  height: 100px;
  color: #292f6d;
}

h2 {
  font-size: 2.5rem;
  font-weight: normal;
}
</style>
